import React from "react";

import Balance from './Balance';
import TransactionHistory from './TransactionHistory';

export default (props) => {

    const { transactions, currentUser, withdrawMoney, payOutList, showBalancePopup2 } = props;

    return(
        <div className="tab-content profile-info tab-content1 active">
            <Balance
                currentUser={currentUser}
                withdrawMoney={withdrawMoney}
                showBalancePopup2={showBalancePopup2}/>

                {
                    payOutList.isFetching ? null
                    :
                    payOutList.data.results.length ?
                    <div className="operations-history">
                        <h3>Операции в обработке</h3>
                        <ul className="items-list operations-history-list">
                        {
                            payOutList.data.results.map((item, index) =>
                                <li key={index} className="list-item">
                                    <div className="name">Вывод средств (ждет подтверждения администратора)</div>
                                    <div className={"balance-change text_green"}>{item.amount} р.</div>
                                </li>
                            )
                        }
                        </ul>
                    </div>
                    : null
                }
        
            <TransactionHistory transactions={transactions}/>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/Account/Balance/IndividualContent.js